export class UpdatePasswordRequest {
  constructor(
    public user_id: number,
    public old_password: string,
    public new_password: string
  ) {}
}
